"use client";
// import {
//   updatePatreonMembership,
//   disconnectFromPatreon,
// } from "../../../lib/api/patreon";
import React from "react";
// import { getDiscordStats } from "@/lib/api/discord";
import { useGlobalContext } from "../../../app/context/store";
import { IS_MAIN_SITE } from "@/components/shared/sites/sites";
import { getLocalizedPath } from "@/components/shared/formatURL";
import { QueueType, useGenerator } from "@/app/context/GeneratorContext";

const PremiumComponent = ({ translations }: { translations: any }) => {
  const { user } = useGlobalContext();
  const { state } = useGenerator();
  // const [data, setData] = useState<any>(null);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState<Error | null>(null);
  // const [countdown, setCountdown] = useState("");
  // const [isExpired, setIsExpired] = useState(false); // State to track if the countdown is expired

  // function isSubStar() {
  //   if (
  //     siteConfiguration.category === "Furry" ||
  //     siteConfiguration.category === "Hentai"
  //   ) {
  //     return true;
  //   }
  //   return false;
  // }

  // function IS_MAIN_SITE {
  //   if (siteConfiguration.category === "Porn") {
  //     return true;
  //   }
  //   return false;
  // }

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const stats = await getDiscordStats();
  //       setData(stats);
  //       setLoading(false);
  //     } catch (err) {
  //       //@ts-ignore
  //       setError(err);
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();

  //   // Countdown timer logic
  //   const targetDate =
  //     new Date("2024-01-13T00:19:34.372+00:00").getTime() +
  //     7 * 24 * 60 * 60 * 1000;
  //   const interval = setInterval(() => {
  //     const now = new Date().getTime();
  //     const distance = targetDate - now;

  //     if (distance < 0) {
  //       clearInterval(interval);
  //       setIsExpired(true); // Set isExpired to true when countdown is over
  //       setCountdown("Expired");
  //     } else {
  //       const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //       const hours = Math.floor(
  //         (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  //       );
  //       const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //       const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  //       setCountdown(`${days}d ${hours}h ${minutes}m ${seconds}s`);
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);

  // const handleLinkAccount = async () => {
  //   if (!user?.membership) {
  //     const token = localStorage.getItem("jwtToken");
  //     if (!token) {
  //       window.location.href = `${process.env.NEXT_PUBLIC_BACKEND_URL}`;
  //     } else {
  //       window.location.href = `${process.env.NEXT_PUBLIC_BACKEND_URL}/subscribestar/connect?id=${token}&origin=${process.env.NEXT_PUBLIC_BASE_URL}`; //subscribestar
  //     }
  //   } else {
  //     await disconnectFromPatreon();
  //     window.location.reload();
  //   }
  // };

  return (
    <>
      {/* {isSubStar() ? (
        <div className="mt-2 flex w-full cursor-default select-none flex-col rounded-md border-[0.5px] border-[#3C3C3C] bg-[#2b2d31] p-4">
          <p
            className="animate-text bg-gradient-to-r from-[#0772DD] via-[#DD0772] to-[#DD0772]
          bg-clip-text font-semibold 
          uppercase  text-transparent underline"
          >
            {isExpired ||
            user.membership?.source === undefined ||
            user._id === "none" ||
            user.membership?.level === 0
              ? locale.getPremiumNow
              : `${countdown} ${locale.untilExpiry}`}
          </p>
          <a
            className="mx-auto mt-auto w-full lg:mb-auto lg:mt-auto lg:w-auto"
            target="_blank"
            rel="noopener noreferrer"
            href="https://subscribestar.adult/createaiart"
          >
            <button className="focus-visible:ring-ring ring-offset-background mb-0 mt-2 inline-flex h-10 w-full transform items-center justify-center whitespace-nowrap rounded-md bg-[#DD0772] px-4 py-2 text-sm font-medium text-[#e9ffec] transition duration-500 ease-in-out hover:scale-105 hover:bg-[#0772DD] hover:brightness-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 lg:mb-2 lg:mt-4">
              {isExpired ||
              user.membership?.source === undefined ||
              user._id === "none" ||
              user.membership?.level === 0
                ? locale.upgradeSubStar
                : locale.renewSubStar}
            </button>
          </a>
        </div>
      ) : ( */}
      <>
        {user.membership?.source === undefined ||
        user._id === "none" ||
        user.membership?.level === 0 ? (
          <div className="mt-0 flex w-full cursor-default select-none flex-col rounded-md border-[0.5px] border-[#3C3C3C] bg-[#2b2d31] p-4">
            <p
              className="animate-text bg-gradient-to-r from-[#FF6200] via-[#FFCC18] to-[#FFCC18]
                bg-clip-text font-semibold 
                uppercase  text-transparent [text-decoration:none]"
            >
              {state.currentQueueType === QueueType.Turbo
                ? translations.getPremiumNow1
                : translations.getPremiumNow2}
            </p>
            <a
              className="mx-auto mt-auto w-full lg:mb-auto lg:mt-auto lg:w-auto"
              target="_blank"
              rel="noopener noreferrer"
              href={getLocalizedPath("upgrade") + "?ref=generator"}
            >
              <button className="focus-visible:ring-ring ring-offset-background mb-0 mt-2 inline-flex h-10 w-full transform items-center justify-center whitespace-nowrap rounded-md bg-[#FFCC18] px-4 py-2 text-sm font-black italic text-black transition duration-500 ease-in-out [text-decoration:none] hover:scale-105 hover:bg-[#FF6200] hover:brightness-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 lg:mb-2 lg:mt-4">
                {IS_MAIN_SITE ? translations.upgradeCCBill1Dollar : translations.upgradeSubStar}
              </button>
            </a>
          </div>
        ) : null}
      </>
    </>
  );
};

export default PremiumComponent;
